import React from 'react';
import { Row, Col } from 'antd';
import { Footer } from './Footer';
import { Header } from '@/components/Settings/DataExtraction/ExtractionType/Hierarchy/Steps/Header';
import { GeneralInformationForm } from './Form';
import { useDataExtractionReport } from '@/context/DataExtractionReport';
import { StepsContainer } from '../../styles';

export function GeneralInformation() {
	const { gutterLayout } = useDataExtractionReport();

	return (
		<Row gutter={gutterLayout}>
			<Col span={24}>
				<StepsContainer>
					<Row gutter={gutterLayout} justify="space-between">
						<Col span={24}>
							<Header
								title="General information"
								description="Choose the hierarchy and period for data collection. These selections will determine the content available for extraction."
							/>
						</Col>
						<Col span={24}>
							<GeneralInformationForm />
						</Col>
					</Row>
				</StepsContainer>
			</Col>
			<Col span={24}>
				<Footer />
			</Col>
		</Row>
	);
}
